var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimsAtom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 321,
    viewBox: "0 0 301 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.621 176.659L130.35 163.746L146.01 277.487",
    stroke: "#263238",
    strokeWidth: 2.3576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.194 187.782C206.037 174.409 210.265 156.955 223.639 148.798C237.012 140.64 254.466 144.869 262.623 158.242C270.781 171.616 266.552 189.07 253.179 197.227C239.805 205.384 222.351 201.156 214.194 187.782Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.129 176.647C215.717 168.227 219.82 159.853 227.518 155.158",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.244 291.29C106.621 275.512 111.609 254.921 127.387 245.297C143.164 235.674 163.756 240.662 173.379 256.44C183.003 272.217 178.014 292.809 162.237 302.432C146.459 312.056 125.868 307.067 116.244 291.29Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.335 277.698C117.863 267.797 122.657 257.955 131.732 252.42",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8533 110.529C21.6512 100.361 24.8662 87.0907 35.0343 80.8886C45.2024 74.6865 58.473 77.9015 64.6751 88.0696C70.8772 98.2376 67.6621 111.508 57.4941 117.71C47.326 123.912 34.0554 120.697 27.8533 110.529Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5851 102.657C29.2764 96.2316 32.3815 89.8161 38.2837 86.216L29.5851 102.657Z",
    fill: "#80FFAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5851 102.657C29.2764 96.2316 32.3815 89.8161 38.2837 86.216",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.617 189.072C87.7981 169.695 93.9248 144.406 113.301 132.587C132.678 120.769 157.967 126.895 169.786 146.272C181.605 165.649 175.478 190.938 156.102 202.757C136.725 214.576 111.436 208.449 99.617 189.072Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.954 171.788C101.371 159.659 107.271 147.591 118.362 140.826",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimsAtom1);
export default __webpack_public_path__ + "static/media/lims-atom-1.e3bb73a8a2d4c38d378fecb0b1f8eeec.svg";
export { ForwardRef as ReactComponent };